var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUspDetailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 26,
    rx: 5,
    fill: "#50C878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5276 7.59196L10.9368 6.00084C10.7962 5.86024 10.6054 5.78125 10.4066 5.78125C10.2077 5.78125 10.017 5.86024 9.87631 6.00084L7.75493 8.12221C7.68526 8.19186 7.62999 8.27456 7.59228 8.36557C7.55457 8.45658 7.53516 8.55414 7.53516 8.65265C7.53516 8.75117 7.55457 8.84872 7.59228 8.93973C7.62999 9.03075 7.68526 9.11344 7.75493 9.18309L9.34606 10.7738M15.8497 18.0275L17.4404 19.6186C17.5101 19.6883 17.5928 19.7435 17.6838 19.7812C17.7748 19.819 17.8724 19.8384 17.9709 19.8384C18.0694 19.8384 18.1669 19.819 18.258 19.7812C18.349 19.7435 18.4317 19.6883 18.5013 19.6186L20.6227 17.4972C20.7633 17.3566 20.8423 17.1658 20.8423 16.967C20.8423 16.7681 20.7633 16.5774 20.6227 16.4367L19.0316 14.8456",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6282 8.48759L18.5069 6.36627C18.214 6.07337 17.7391 6.07337 17.4462 6.36627L7.36996 16.4425C7.07707 16.7354 7.07707 17.2103 7.36996 17.5032L9.49128 19.6245C9.78417 19.9174 10.259 19.9174 10.5519 19.6245L20.6282 9.54825C20.9211 9.25535 20.9211 8.78048 20.6282 8.48759Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.75C14.4142 13.75 14.75 13.4142 14.75 13C14.75 12.5858 14.4142 12.25 14 12.25C13.5858 12.25 13.25 12.5858 13.25 13C13.25 13.4142 13.5858 13.75 14 13.75Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.25C12.9142 15.25 13.25 14.9142 13.25 14.5C13.25 14.0858 12.9142 13.75 12.5 13.75C12.0858 13.75 11.75 14.0858 11.75 14.5C11.75 14.9142 12.0858 15.25 12.5 15.25Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.25C15.9142 12.25 16.25 11.9142 16.25 11.5C16.25 11.0858 15.9142 10.75 15.5 10.75C15.0858 10.75 14.75 11.0858 14.75 11.5C14.75 11.9142 15.0858 12.25 15.5 12.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUspDetailIcon);
export default __webpack_public_path__ + "static/media/USPDetailIcon.c49e4dc5b9e28d7e59bcd3b2277a4c0f.svg";
export { ForwardRef as ReactComponent };